/* eslint-disable @next/next/no-img-element */
import { ServiceCardSb } from '@/components/findex-connect/types/component-types-sb'

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion'
import { CarouselItem } from '../ui/carousel'

export const ServiceCard: React.FC<
  Pick<ServiceCardSb, 'title' | 'subtitle' | 'contentItems' | 'image'> & {
    className?: string
    isLastItem?: boolean
    isActiveCard?: boolean
  }
> = ({
  title,
  subtitle,
  contentItems,
  image,
  className,
  isLastItem = false,
  isActiveCard = false,
}) => {
  return (
    <CarouselItem
      is="div"
      className={
        'SERVICECARD-CAROUSEL-ITEM flex h-auto w-full max-w-[1200px] basis-5/6 flex-col gap-6 overflow-hidden rounded-xl bg-white pl-0 select-none md:basis-4/5 md:flex-row-reverse ' +
        className +
        (isLastItem ? ` mr-[16%] md:mr-[20%]` : '')
      }
    >
      <div className="IMAGE-CONTAINER min-h-[220px] w-full bg-black/10 md:min-h-full md:w-1/2">
        {image?.filename && (
          <img
            src={image?.filename || ''}
            alt={image?.alt || 'Service Image'}
            width={'100%'}
            height={'100%'}
            className="h-full w-full object-cover"
          />
        )}
      </div>
      <div className="SERVICECARD-CONTENT flex grow-1 flex-col p-3 md:w-1/2 md:p-10 md:pr-4">
        {title && (
          <h2 className="mb-2 self-start text-wrap break-words" tabIndex={isActiveCard ? 0 : -1}>
            {title}
          </h2>
        )}

        <p className="textblock-sm text-subtle-light text-wrap break-words italic md:mb-8">
          {subtitle || ' '}
        </p>
        <Accordion
          type="single"
          is="ul"
          collapsible
          defaultValue={'item-0'}
          className="tab-outline-primary !overflow-visible overflow-y-auto md:mb-6"
        >
          {contentItems?.map(({ heading, text }, cardNumber) => (
            <AccordionItem
              value={`item-${cardNumber}`}
              className="ACCORDION-ITEM border-b-black/10"
              key={`${cardNumber}-${heading}`}
            >
              <AccordionTrigger
                className="ACCORDION-TRIGGER tab-outline-primary m-0 py-4 focus-within:!outline-offset-1 focus:mb-2 focus:rounded-2xl"
                tabIndex={isActiveCard ? 0 : -1}
              >
                <h4 className="text-prominent !text-20 mb-0 leading-[1.1]">{heading}</h4>
              </AccordionTrigger>
              <AccordionContent className="AccordionContent">
                <p className="para-sm text-text line-clamp-4">{text}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </CarouselItem>
  )
}
